<div class="FloatingTab" [class._opened]="showTab">
  <div class="FloatingTab-Body">
    <one-icon class="FloatingTab-Close" *ngIf="closeButton" name="close" (click)="showTab = false"></one-icon>
    <ng-content></ng-content>
  </div>
  <div class="FloatingTab-Tab" (click)="showTab = !showTab">
    {{tabText}}
  </div>
</div>